"use client"

import { motion } from "framer-motion"
import { ReactNode } from "react"

type StaggerItemProps = {
  children: ReactNode
  className?: string
}

export const StaggerItem = ({ children, className = "" }: StaggerItemProps) => {
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
    },
  }

  return (
    <motion.div
      variants={itemVariants}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.4, 0.25, 1] as any
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
